import React, { Component } from "react";
import { Spinner } from "reactstrap";
import swal from "sweetalert";
import CustomFullSpinner from "../../../components/WebsiteComponents/CustomFullSpinner";
import CustomModal from "../../../components/WebsiteComponents/CustomModal";
import { axiosGet, axiosPost } from "../../../utils/AxiosApi";
import { fileUrl, moduleName, URL } from "../../../utils/Constants";
import {
  displayConfirmDeleteAlert,
  displayErrorAlert,
  DISPLAYMESSAGE,
} from "../../../utils/DisplayMessage";
// import CreateTravelAgency from "./CreateTravelAgency";
import {
  checkRolePermissions,
  getRolesFromStorage,
} from "../../../utils/Helper";
import CreateTravelAgency from "../TravelAgency/CreateTravelAgency";
import Pagination from "react-js-pagination";
import TicketContainer from "../TravelAgency/TicketContainer";

class TravelAgency extends Component {
  state = {
    createModal: false,
    dataSpinner: false,
    deletePermission: false,
    edit: false,
    editPermission: false,
    selectedData: "",
    travelChildAgencies: [],
    ticketsList: false,
    ticketsListData: [],
    activeOperatorID: null,
  };

  componentDidMount() {
    this.getTravelChildAgencies();
    this.permissions();
  }

  getTravelChildAgencies = (pageNumber, paginated_value) => {
    let page = pageNumber || this.state.current_page
    let paginatedValue = paginated_value || this.state.paginated_value
    let param = {
      page: page,
      paginated_value: paginatedValue,
    }
    this.setState({ dataSpinner: true, travelAgencies: [] }, function () {
      //required to change the api endPoint
      axiosPost(
        URL.travelChildAgency, param,
        (response) => {
          if (response.status === 200) {
            this.setState({
              travelChildAgencies: response.data.data.items,
              totalItemsCount: response.data.data.totalData,
              current_page: page,
              paginated_value:paginatedValue,
              dataSpinner: false,
            });
          }
        },
        (err) => {
          displayErrorAlert(err);
          this.setState({ dataSpinner: false });
        }
      );
    });
  };

  handleCreateModal = () => {
    this.setState({ createModal: !this.state.createModal, edit: false });
  };

  handleDeleteBtnClick = (data) => {
    let param = { id: data };
    displayConfirmDeleteAlert(param, this.handleDelete);
  };

  handleDelete = (param) => {
    //change the API endPoint
    this.setState({ loader: true });
    axiosGet(
      URL.deleteTravelChildAgency + "/" + param.id,
      (response) => {
        if (response.status === 200) {
          swal("Success", DISPLAYMESSAGE.deleteSuccess, "success");
          this.getTravelChildAgencies();
          this.setState({ loader: false });
        }
      },
      (err) => {
        this.getTravelChildAgencies();
        this.setState({ loader: false });
      }
    );
  };

  handleEdit = (item) => {
    this.setState({ selectedData: item, edit: true, createModal: true });
  };

  permissions = () => {
    this.setState({
      editPermission: checkRolePermissions(
        "updateChild",
        moduleName.travelChildAgency
      ),
      deletePermission: checkRolePermissions(
        "deleteChild",
        moduleName.travelChildAgency
      ),
    });
  };

  handleViewDetails = (item) => {
    axiosPost(
      URL.viewAllTickets,
      { operator_id: item ? item.id : this.state.activeOperatorID },
      (response) => {
        this.setState({
          ticketsListData: response.data.data.items,
          ticketsList: true,
          activeOperatorID: item ? item.id : this.state.activeOperatorID,
        });
      }
    );
  };

  handlePaginatedValueChange = (value) => {
    let valuePage = parseInt(value);
    this.setState({ paginated_value: valuePage }, () => {
      this.getTravelChildAgencies(1, valuePage);
    });
  };

  render() {
    const { current_page, paginated_value, totalItemsCount } = this.state;
    const roles = getRolesFromStorage();

    return (
      <>
        {this.state.loader ? <CustomFullSpinner /> : ""}
        <div className="dashboardHeader">
          <strong>Operator</strong>
        </div>
        <div className="container-fluid h-100">
          <div className="row mt-2">
            <div className="col">
              {checkRolePermissions(
                "createChild",
                moduleName.travelChildAgency
              ) ? (
                <button
                  className="btn btn-success"
                  onClick={this.handleCreateModal}
                >
                  Add Operator
                </button>
              ) : null}
            </div>
          </div>
          <div className="row mt-2 h-100">
            <div className="col d-flex align-items-center justify-content-between flex-column">
              <div className="table-responsive w-100">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th>S.N</th>
                      <th>Logo</th>
                      <th>Name</th>
                      <th>Address</th>
                      <th>Contact Details</th>
                      <th>Email</th>
                      {this.state.editPermission ||
                        this.state.deletePermission ? (
                        <th>Options</th>
                      ) : null}
                    </tr>
                  </thead>
                  {/* <tbody>
                  <tr>
                    <td>let s</td>
                    <td>let s</td>
                    <td>let s</td>
                    <td>let s</td>
                    <td>let s</td>
                    <td>let s</td>
                  </tr>
                </tbody> */}

                  <tbody>
                    {this.state.travelChildAgencies?.length > 0 ? (
                      this.state.travelChildAgencies?.map((item, idx) => {
                        return (
                          <tr key={idx}>
                            <td>{idx + 1}</td>
                            <td>
                              {item.media.length > 0 ? (
                                <img
                                  src={
                                    fileUrl +
                                    "/" +
                                    item.media[0].id +
                                    "/" +
                                    item.media[0].file_name
                                  }
                                  className="logoDisplay"
                                />
                              ) : null}
                            </td>
                            <td>
                              {item.name}

                              <br />
                              {roles[0] === "Network Admin" && (
                                <span className="badge rounded-pill bg-info text-dark text-white">
                                  {item.travel_agency.name}
                                </span>
                              )}
                            </td>
                            <td>{item.address}</td>
                            <td>{item.contact_details}</td>
                            <td>{item.email}</td>
                            {this.state.editPermission ||
                              this.state.deletePermission ? (
                              <td>
                                <button
                                className="btn btn-info ms-3"
                                onClick={() => this.handleViewDetails(item)}
                              >
                                <i class="fa-solid fa-eye"></i>
                              </button>
                                {this.state.editPermission ? (
                                  <button
                                    className="btn btn-primary m-1"
                                    onClick={() => this.handleEdit(item)}
                                  >
                                    <i class="fa-solid fa-pen-to-square"></i>
                                  </button>
                                ) : null}
                                {this.state.deletePermission ? (
                                  <button
                                    className="btn btn-danger m-1"
                                    onClick={() =>
                                      this.handleDeleteBtnClick(item.id)
                                    }
                                  >
                                    <i class="fa-solid fa-trash"></i>
                                  </button>
                                ) : null}
                              </td>
                            ) : null}
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td
                          colSpan={
                            this.state.editPermission ||
                              this.state.deletePermission
                              ? 7
                              : 6
                          }
                          className="text-center p-3"
                        >
                          {this.state.dataSpinner ? (
                            <>
                              <Spinner color="primary"></Spinner>
                              <br />
                              Loading Data...
                            </>
                          ) : (
                            "No Operator found. Create one first"
                          )}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              {this.state.travelChildAgencies.total <= 10 ? (
                <></>
              ) : (
                <div className="paginationContainer">
                  <Pagination
                    activePage={current_page}
                    itemsCountPerPage={paginated_value}
                    totalItemsCount={totalItemsCount}
                    onChange={(pageNumber) =>
                      this.getTravelChildAgencies(pageNumber, paginated_value)
                    }
                    itemClass="page-item"
                    linkClass="page-link"
                    firstPageText="First"
                    lastPageText="Last"
                  />
                  <div className="paginatoion_paginated_value ml-3">
                    <select
                      className="form-control"
                      value={this.state.paginated_value}
                      onChange={(e) => this.handlePaginatedValueChange(e.target.value)}
                    >
                      <option value={10}>10</option>
                      <option value={20}>20</option>
                      <option value={30}>30</option>
                      <option value={40}>40</option>
                      <option value={50}>50</option>
                    </select>
                  </ div>
                </div>
              )}
            </div>
          </div>

          <CustomModal
            modal={this.state.createModal}
            modalBody={
              <CreateTravelAgency
                getTravelAgencies={this.getTravelChildAgencies}
                handleCreateModal={this.handleCreateModal}
                selectedData={this.state.selectedData}
                edit={this.state.edit}
                isChildTravelAgency={true}
              />
            }
            modalHeader={this.state.edit ? "Edit Operator" : "Add Operator"}
            size="lg"
            toggleModal={this.handleCreateModal}
          ></CustomModal>
        </div>

        <CustomModal
          fullWidth={true}
          modal={this.state.ticketsList}
          modalBody={
            <TicketContainer ticketsListData={this.state.ticketsListData} />
          }
          modalHeader="Details"
          size="lg"
          toggleModal={() =>
            this.setState({
              ticketsList: !this.state.ticketsList,
            })
          }
        ></CustomModal>
      </>
    );
  }
}

export default TravelAgency;
